import React from "react"
import { Redirect } from "react-router-dom"
import { useSprintsAuthorizationQuery } from "#/services/user/hooks/useSprintsQuery"
import { DbgPaths } from "#/utils/Paths"
import SprintIntroPage from "./page"

export function SprintsLandingPageRoute(): JSX.Element {
  const { data: shouldShowSprintsPage } = useSprintsAuthorizationQuery({
    select: (data) => data.memberIsSprintsAuthorized || data.partnerIsSprintsAuthorized
  })

  if (!shouldShowSprintsPage) {
    return <Redirect to={DbgPaths.METABOLIC_FERTILITY_HEALTH} />
  }

  return <SprintIntroPage />
}
